
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/[[...slug]]",
      function () {
        return require("private-next-pages/help/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/[[...slug]]"])
      });
    }
  